import React from "react";
import { ArrowRight, Lightbulb, Info, AlertTriangle } from "lucide-react";
import { RichText } from "./RichText";
import { BUTUNLESIK } from "@/data/k405Notes";

const TONES = {
  exam: { cls: "nb-box nb-box-exam", icon: Lightbulb, label: "Sınavda çıkar" },
  info: { cls: "nb-box nb-box-info", icon: Info, label: "Not" },
  warn: { cls: "nb-box nb-box-warn", icon: AlertTriangle, label: "Dikkat" },
};

export function SkillsGrid() {
  return (
    <div className="skills-grid" data-testid="skills-grid">
      {BUTUNLESIK.map(([code, name, def]) => (
        <div key={code} className="skill-item pdf-avoid">
          <div className="skill-code">{code}</div>
          <div>
            <div className="skill-name">{name}</div>
            <div className="skill-def">{def}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

export function Blocks({ blocks }) {
  return blocks.map((b, i) => {
    if (b.p) return <p key={i} className="nb-p"><RichText text={b.p} /></p>;
    if (b.ul)
      return (
        <ul key={i} className="nb-ul">
          {b.ul.map((x, j) => <li key={j}><RichText text={x} /></li>)}
        </ul>
      );
    if (b.ol)
      return (
        <ol key={i} className="nb-ol">
          {b.ol.map((x, j) => <li key={j}><RichText text={x} /></li>)}
        </ol>
      );
    if (b.table)
      return (
        <div key={i} className="nb-table-wrap">
          <table className="nb-table">
            <thead>
              <tr>{b.table.head.map((h, j) => <th key={j}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {b.table.rows.map((r, j) => (
                <tr key={j}>{r.map((c, k) => <td key={k}><RichText text={c} /></td>)}</tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    if (b.box) {
      const t = TONES[b.tone] || TONES.info;
      const Icon = t.icon;
      return (
        <div key={i} className={`${t.cls} pdf-avoid`}>
          <div className="nb-box-label"><Icon size={14} /> {t.label}</div>
          <div><RichText text={b.box} /></div>
        </div>
      );
    }
    if (b.formula)
      return (
        <div key={i} className="nb-formula pdf-avoid">
          {b.formula.map((f, j) => <div key={j} className="nb-formula-line">{f}</div>)}
        </div>
      );
    if (b.flow)
      return (
        <div key={i} className="nb-flow pdf-avoid">
          {b.flow.map((f, j) => (
            <React.Fragment key={j}>
              <span className="nb-flow-step">{f}</span>
              {j < b.flow.length - 1 && <ArrowRight size={14} className="nb-flow-arrow" />}
            </React.Fragment>
          ))}
        </div>
      );
    if (b.skills) return <SkillsGrid key={i} />;
    return null;
  });
}
